import { trackerConfig } from "../config";
import type { Tracker } from "../types";

/**
 * Meta (Facebook) Pixel. Injected only after the user grants the "marketing"
 * category. No-op when `VITE_META_PIXEL_ID` is blank.
 *
 * Revocation note: like gtag, fbevents cannot be unloaded once injected —
 * revoking marketing prevents future loads; the script clears on reload.
 */
let loaded = false;

export const metaPixel: Tracker = {
  id: "meta-pixel",
  category: "marketing",
  label: "Meta Pixel",
  isConfigured(): boolean {
    return trackerConfig.metaPixelId.length > 0;
  },
  load(): void {
    if (loaded || !this.isConfigured()) return;
    loaded = true;
    const id = trackerConfig.metaPixelId;

    // Standard fbevents bootstrap, ported from Meta's snippet: stand up the
    // `fbq` queue + loader flags before the async script lands so calls made
    // immediately are replayed once fbevents.js finishes loading.
    const fbq = function (...args: unknown[]): void {
      const q = window.fbq!;
      if (q.callMethod) q.callMethod(...args);
      else q.queue?.push(args);
    } as FbqFn;
    fbq.queue = [];
    fbq.loaded = true;
    fbq.version = "2.0";
    if (!window._fbq) window._fbq = fbq;
    window.fbq = fbq;

    const script = document.createElement("script");
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(script);

    fbq("init", id);
    fbq("track", "PageView");
  },
};
